var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons8-facebook-nuevo-50") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ESTANDARIZACI\\xD3N-PAGINAS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UPDATE-Footer",
    transform: "translate(-369.000000, -125.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-facebook-nuevo-50",
    transform: "translate(369.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.71590909,0 0,6.75042833 0,15.0770988 C0,22.6362079 5.53977273,28.8774415 12.7581818,29.9677898 L12.7581818,19.0732153 L9.04704545,19.0732153 L9.04704545,15.1099943 L12.7581818,15.1099943 L12.7581818,12.4728726 C12.7581818,8.1066819 14.8745455,6.18983438 18.4847727,6.18983438 C20.2138636,6.18983438 21.1281818,6.31867504 21.5611364,6.37761279 L21.5611364,9.83712164 L19.0984091,9.83712164 C17.5656818,9.83712164 17.0304545,11.2975443 17.0304545,12.9436893 L17.0304545,15.1099943 L21.5222727,15.1099943 L20.9127273,19.0732153 L17.0304545,19.0732153 L17.0304545,30 C24.3518182,29.0014849 30,22.7095374 30,15.0770988 C30,6.75042833 23.2840909,0 15,0 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.35b372dcf0a0c39301c46dc15183b5b8.svg";
export { ForwardRef as ReactComponent };